import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../contexts/AuthProvider";
import { Button, Container } from "react-bootstrap";
import SocketLog from "../components/SocketLog";

const Admin = () => {
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const logout = async () => {
    // if used in more components, this should be in context
    // axios to /logout endpoint
    setAuth({});
    navigate("/login");
  };

  return (
    <Container className="my-3">
      <h1 className="text-center">Admin</h1>
      <br />
      <SocketLog />
      <br />
      <Button variant="secondary" onClick={logout}>
        Sign Out
      </Button>
    </Container>
  );
};

export default Admin;
